export default "__VITE_ASSET__bb061776__"